var render = function render(){var _vm=this,_c=_vm._self._c;return _c('StatusChip',{attrs:{"entity":_vm.rev,"status":_vm.revStatus,"availableStatus":_vm.availableStatus,"isEditable":_vm.canEdit,"large":_vm.large,"showValidationIcons":_vm.showValidationIcons},on:{"onChange":_vm.handleSelectStatus}})
}
var staticRenderFns = []

export { render, staticRenderFns }